import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import { ClaimCounter, ReferralsPortalApplicationStatus } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class ClaimCountersHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadApplicationsCounters(): Observable<ClaimCounter[]> {
    return this.httpApi.get(`/referral/applications/counters`, {
      status: ReferralsPortalApplicationStatus.Claimed,
    });
  }
}
